import React from 'react';
// import PickupDropSearch from '../PickupDropSearch/PickupDropSearch';

import useRequest from '../../../context/useRequest';
import CitySearchLocation from './CitySearchLocation';

const UnifiedForm = ({ activeTab, modifySearch, searchData }) => {
    const { error: searchError, sendRequest } = useRequest();

    const handleSearch = async (formData) => {
        try {
            const response = await sendRequest({
                method: 'POST',
                url: '/cab/search',
                body: formData
            });
            return response;
        } catch (error) {
    
            throw error;
        }
    };

    const getSearchComponent = () => {
        const searchConfigs = {
            tab1: {
                searchType: "airport",
                labels: {
                    pickup: 'Pickup Location',
                    drop: 'Airport Location'
                }
            },
            tab2: {
                searchType: "local",
                labels: {
                    pickup: 'Pickup Location',
                    drop: 'Drop Address'
                }
            },
            tab3: {
                searchType: "out_station",
                labels: {
                    pickup: 'Pickup City',
                    drop: 'Drop City'
                }
            },
            tab4: {
                searchType: "self_drive",
                labels: {
                    pickup: 'Pickup Location',
                    drop: 'Drop Location'
                }
            }
        };

        const config = searchConfigs[activeTab];
        
        if (!config) return null;

        return (
            <CitySearchLocation 
                activeTab={activeTab}
                onSearch={handleSearch}
                searchType={config.searchType}
                labels={config.labels}
                modifySearch={modifySearch}
                searchData={searchData}
            />
        );
    };

    return (
        <>
        <div className="search-container">
            {searchError && (
                <div className="error-message" >
                    {typeof searchError === 'string' 
                        ? searchError 
                        : 'An error occurred during the search.'
                    }
                </div>
            )}
            {getSearchComponent()}
        </div>
        
        </>
    );
};

export default UnifiedForm;